import ES from "./locales/es";
import EN from "./locales/en";

export default {
  ES,
  EN
};
